(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/index.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/index.js');
"use strict";


const drawHandlers = svs.isServer ? require('./draw-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.drawHandlers;
const pixHandlers = svs.isServer ? require('./pix-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.pixHandlers;
const playerHandlers = svs.isServer ? require('./player-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.playerHandlers;
const uploadHandlers = svs.isServer ? require('./upload-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.uploadHandlers;
const handlers = [...drawHandlers, ...pixHandlers, ...playerHandlers, ...uploadHandlers];
if (svs.isServer) {
  module.exports = handlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.index', handlers);
}

 })(window);